import { useEffect, useState } from "react";

import { Button, Table } from "reactstrap";

//Componentes
import Paginacao from "@/frontend/componentes/Paginacao";

//Common
import { fn_formatarDataHora } from "@/common/utils/date";
import { fn_getResultPaginado, PAGINACAO } from "@/common/utils/paginacao";
import { SITUACAO_CONFERENCIA } from "@/common/constantes";
import { fn_getTipoIntegracao } from "@/common/siig";

//Util
import { fn_getJsxSituacaoConferencia } from "@/frontend/utils/siig/solicitacao";

//Telas
import ModalAutorizacaoLog from "@/frontend/pages/acesso/autorizacao/modal_log_autorizacao";

/*
 * Aba Conferências da tela "Mais inf" da solicitação.
 * Lista as conferências de todos os pagamentos da solicitação.
 * @conferencias: Conferências já ordenadas pelo número do pagamento e pela data (fn_montarConferenciasPagamentos)
 */
function TSolicitacao_det_aba_conferencias({ solicitacao, conferencias }) {
  //### USE STATE ###
  const [modalOpenLog, setModalOpenLog] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [result, setResult] = useState({
    pages: 0,
    count: 0,
    items: [],
    offset: 0,
    limit: 0,
  });

  const [autorizacaoLog, setAutorizacaoLog] = useState(null);

  //### USE EFFECT ###
  //Paginação
  useEffect(() => {
    setResult(
      fn_getResultPaginado(
        pageNumber,
        conferencias,
        PAGINACAO.ITENS_POR_PAGINA_POPUP,
      ),
    );
  }, [pageNumber, conferencias]);

  //### EVENTOS ###
  //OnClick - Botão Log cancelamento
  function handleBotaoLogCancelamento(conf) {
    setAutorizacaoLog(conf.autorizacao_log_canc);
    setModalOpenLog(true);
  }

  return (
    <div className="m-2">
      <Table responsive>
        <thead>
          <tr>
            <td width="10%" align="center" className="table-header">
              Pagamento
            </td>

            <td width="13%" align="center" className="table-header">
              Data
            </td>

            <td width="13%" className="table-header">
              Tipo integração
            </td>

            <td width="7%" align="center" className="table-header">
              Retirada
            </td>

            <td width="17%" className="table-header">
              Usuário
            </td>

            <td className="table-header">Comentário</td>

            <td width="12%" align="center" className="table-header">
              Situação
            </td>

            <td width="1%" className="table-header"></td>
          </tr>
        </thead>

        <tbody>
          {result.items.map((conf) => (
            <tr key={conf.id}>
              <td align="center">
                <strong>{conf.num_pag}</strong> / {solicitacao.qtde_pagamentos}
              </td>

              <td align="center">{fn_formatarDataHora(conf.data)}</td>

              <td>{fn_getTipoIntegracao(conf.tipo_integracao)?.label}</td>

              <td align="center">
                {conf.tipo_integracao &&
                  (conf.integracao_retirada == "S" ? "Sim" : "Não")}
              </td>

              <td>{conf.usuario?.nome}</td>

              <td>{conf.comentario}</td>

              <td align="center">
                {fn_getJsxSituacaoConferencia(conf.situacao)}
              </td>

              <td align="center">
                {conf.situacao == SITUACAO_CONFERENCIA.CANCELADA && (
                  <Button
                    name="btnLogCanc"
                    size="sm"
                    color="light"
                    onClick={() => handleBotaoLogCancelamento(conf)}
                  >
                    Log
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Paginacao
        result={result}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />

      {modalOpenLog && (
        <ModalAutorizacaoLog
          modalOpen={modalOpenLog}
          toggleModal={() => setModalOpenLog(!modalOpenLog)}
          titulo="Cancelamento conferência pagamento"
          autorizacaoLog={autorizacaoLog}
        />
      )}
    </div>
  );
}

export default TSolicitacao_det_aba_conferencias;
